import type { CalendarItem } from '@efdigital/ll-addon-data';
import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types/xceed';
import { page } from '@efdigital/ll-admin-v2/data/json-api';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { cacheKeyFor, Store } from '@warp-drive/core';
import {
  findRecord,
  query,
  serializePatch,
  updateRecord,
} from '@warp-drive/utilities/json-api';

/**
 * Finds the calendar items for a program and cohort
 * @param programId - The id of the program
 * @param cohortId - The id of the cohort
 * @returns JSON API request to find the calendar items
 */
export function queryCalendarItems(programId: string, cohortId: string) {
  return query<CalendarItem>(
    DataTypeXceed.CalendarItem,
    {
      'filter[category1]': 'Xceed',
      'filter[category2]': 'Cohort',
      'filter[category3]': programId,
      'filter[category4]': cohortId,
      sort: 'starts',
      ...page({ offset: 0, limit: 500 }),
    },
    jsonApiOptions
  );
}

export function findCalendarItem(calendarItemId: string) {
  return findRecord<CalendarItem>(DataTypeXceed.CalendarItem, calendarItemId, {
    ...jsonApiOptions,
  });
}

export function updateCalendarItem(calendarItem: CalendarItem, store: Store) {
  const init = updateRecord(calendarItem, {
    ...jsonApiOptions,
    patch: true,
  });

  init.body = JSON.stringify(
    serializePatch(store.cache, cacheKeyFor(calendarItem))
  );

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}
